import * as angular from "angular";
import {IController} from "angular";
import {ContentTemplateModel} from "../../models/content-template.model";
import {ContentTemplatesService} from "../../services/content-templates.service";

export class ContentTemplateCreateViewComponent implements IController {

  template: ContentTemplateModel;
  onSubmit: Function;
  onCancel: Function;

  public templateContentId: string;

  constructor(private contentTemplatesService: ContentTemplatesService) {
  }

  onGetTemplate(externalTemplateId: string, event) {
    event.preventDefault();
    this.contentTemplatesService.getExternalTemplate(externalTemplateId)
      .then((externalTemplate: ContentTemplateModel) => {
        this.template = externalTemplate;
      });
  }

  submit(form) {
    if (form) {
      form.$setSubmitted(true);
      if (form.$valid) {
        this.onSubmit({template: this.template})
      }
    }
  }
}

angular
  .module('bringoz.admin.content-templates')
  .component('contentTemplateCreateView', {
    bindings: {
      template: '<?',
      onSubmit: '&',
      onCancel: '&'
    },
    template: require('./content-template-create-view.html').default,
    controller: ContentTemplateCreateViewComponent
  });
